import { Radar, RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis, ResponsiveContainer } from "recharts";

export default function BlurredRadar({ scores, max = 6 }) {
  const data = [
    { axis: "Porteuse", value: scores?.porteuse || 0 },
    { axis: "Suradaptée", value: scores?.suradaptee || 0 },
    { axis: "Éteinte", value: scores?.eteinte || 0 },
    { axis: "Déconnectée", value: scores?.deconnectee || 0 },
  ];
  return (
    <div className="relative w-full" style={{ height: 340 }}>
      <div
        className="absolute inset-0"
        style={{ filter: "blur(7px) saturate(1.1)", opacity: 0.7 }}
        aria-hidden
      >
        <ResponsiveContainer width="100%" height="100%">
          <RadarChart data={data} outerRadius="72%">
            <PolarGrid stroke="#C49DA6" strokeOpacity={0.5} />
            <PolarAngleAxis dataKey="axis" tick={{ fill: "#98495C", fontSize: 14, fontFamily: "Italiana, serif" }} />
            <PolarRadiusAxis
              angle={90}
              domain={[0, max]}
              tick={false}
              axisLine={false}
            />
            <Radar
              name="Vous"
              dataKey="value"
              stroke="#98495C"
              fill="#98495C"
              fillOpacity={0.45}
              strokeWidth={2}
            />
          </RadarChart>
        </ResponsiveContainer>
      </div>

      {/* subtle veil overlay */}
      <div className="absolute inset-0 pointer-events-none bg-gradient-to-b from-sand-50/0 via-sand-50/30 to-sand-50/70" />
    </div>
  );
}
